import { AlertConfigApiItem, AlertConfigApiSelectItem, AlertConfigFormDto } from "../types";
import fetchApi from "../../../../lib/fetchApi";

const BASE_URL = "/alertConfig";

export const getAlertConfigs = async (): Promise<AlertConfigApiItem[]> => {
    const response = await fetchApi.get(`${BASE_URL}`) as AlertConfigApiItem[];
    return response;
};

export const getAlertConfigsSelect = async (): Promise<AlertConfigApiSelectItem[]> => {
    const response = await fetchApi.get(`${BASE_URL}/select`) as AlertConfigApiSelectItem[];
    return response;
};

export const getAlertConfigById = async (id: number): Promise<AlertConfigApiItem> => {
    const response = await fetchApi.get(`${BASE_URL}/${id}`) as AlertConfigApiItem;
    return response;
};

export const createAlertConfig = async (body: AlertConfigFormDto): Promise<void> => {
    await fetchApi.post(`${BASE_URL}/create`, body);
};

export const updateAlertConfig = async (id: number, body: AlertConfigFormDto): Promise<void> => {
    await fetchApi.put(`${BASE_URL}/${id}`, body);
};

export const deleteAlertConfig = async (id: number): Promise<void> => {
    await fetchApi.delete(`${BASE_URL}/${id}`);
};

